/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as ResetPasswordTaskRouteImport } from './routes/reset-password-task'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NetworkConnectivityRequirementsRouteImport } from './routes/network-connectivity-requirements'
import { Route as EulaRouteImport } from './routes/eula'
import { Route as DocumentationRouteImport } from './routes/documentation'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as DocumentationIndexRouteImport } from './routes/documentation/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SettingsSubscriptionRouteImport } from './routes/settings/subscription'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as PreviewSplatRouteImport } from './routes/preview.$'
import { Route as DocumentationTutorialVueRouteImport } from './routes/documentation/tutorial-vue'
import { Route as DocumentationTutorialReactRouteImport } from './routes/documentation/tutorial-react'
import { Route as DocumentationTutorialAngularRouteImport } from './routes/documentation/tutorial-angular'
import { Route as DocumentationTutorialRouteImport } from './routes/documentation/tutorial'
import { Route as DocumentationTolerancesRouteImport } from './routes/documentation/tolerances'
import { Route as DocumentationStreamingGuideUnrealRouteImport } from './routes/documentation/streaming-guide-unreal'
import { Route as DocumentationStreamingGuideUnityRouteImport } from './routes/documentation/streaming-guide-unity'
import { Route as DocumentationStreamingGuideRouteImport } from './routes/documentation/streaming-guide'
import { Route as DocumentationSdkReferenceRouteImport } from './routes/documentation/sdk-reference'
import { Route as DocumentationOverviewRouteImport } from './routes/documentation/overview'
import { Route as DocumentationNetworkWhitelistingRouteImport } from './routes/documentation/network-whitelisting'
import { Route as DocumentationNetworkConnectivityRequirementsRouteImport } from './routes/documentation/network-connectivity-requirements'
import { Route as DocumentationLocalAgentRouteImport } from './routes/documentation/local-agent'
import { Route as DocumentationInterlucentUploaderRouteImport } from './routes/documentation/interlucent-uploader'
import { Route as DocumentationIdleTimerRouteImport } from './routes/documentation/idle-timer'
import { Route as DocumentationAdmissionTokensRouteImport } from './routes/documentation/admission-tokens'
import { Route as DocumentationAccessTokensRouteImport } from './routes/documentation/access-tokens'
import { Route as CheckSplatRouteImport } from './routes/check.$'
import { Route as AdminToolsRouteImport } from './routes/admin/tools'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminPlanTiersRouteImport } from './routes/admin/plan-tiers'
import { Route as AdminOrganizationsRouteImport } from './routes/admin/organizations'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects/$projectId/index'
import { Route as AdminPoolsIndexRouteImport } from './routes/admin/pools/index'
import { Route as ProjectsProjectIdShareLinksRouteImport } from './routes/projects/$projectId/share-links'
import { Route as ProjectsProjectIdSettingsRouteImport } from './routes/projects/$projectId/settings'
import { Route as ProjectsProjectIdOverviewRouteImport } from './routes/projects/$projectId/overview'
import { Route as ProjectsProjectIdDomainsRouteImport } from './routes/projects/$projectId/domains'
import { Route as ProjectsProjectIdAdmissionTokensRouteImport } from './routes/projects/$projectId/admission-tokens'
import { Route as AdminPoolsPricingRouteImport } from './routes/admin/pools/pricing'
import { Route as AdminPoolsOnDemandAccessRouteImport } from './routes/admin/pools/on-demand-access'
import { Route as AdminPoolsNewPrivatePoolRouteImport } from './routes/admin/pools/new-private-pool'
import { Route as AdminPoolsPoolIdRouteImport } from './routes/admin/pools/$poolId'
import { Route as ProjectsProjectIdProfilesIndexRouteImport } from './routes/projects/$projectId/profiles/index'
import { Route as ProjectsProjectIdApplicationsIndexRouteImport } from './routes/projects/$projectId/applications/index'
import { Route as ProjectsProjectIdProfilesProfileIdRouteImport } from './routes/projects/$projectId/profiles/$profileId'
import { Route as ProjectsProjectIdApplicationsAppIdRouteImport } from './routes/projects/$projectId/applications/$appId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTaskRoute = ResetPasswordTaskRouteImport.update({
  id: '/reset-password-task',
  path: '/reset-password-task',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const NetworkConnectivityRequirementsRoute =
  NetworkConnectivityRequirementsRouteImport.update({
    id: '/network-connectivity-requirements',
    path: '/network-connectivity-requirements',
    getParentRoute: () => rootRouteImport,
  } as any)
const EulaRoute = EulaRouteImport.update({
  id: '/eula',
  path: '/eula',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentationRoute = DocumentationRouteImport.update({
  id: '/documentation',
  path: '/documentation',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentationIndexRoute = DocumentationIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocumentationRoute,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsSubscriptionRoute = SettingsSubscriptionRouteImport.update({
  id: '/settings/subscription',
  path: '/settings/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const PreviewSplatRoute = PreviewSplatRouteImport.update({
  id: '/preview/$',
  path: '/preview/$',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentationTutorialVueRoute =
  DocumentationTutorialVueRouteImport.update({
    id: '/tutorial-vue',
    path: '/tutorial-vue',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationTutorialReactRoute =
  DocumentationTutorialReactRouteImport.update({
    id: '/tutorial-react',
    path: '/tutorial-react',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationTutorialAngularRoute =
  DocumentationTutorialAngularRouteImport.update({
    id: '/tutorial-angular',
    path: '/tutorial-angular',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationTutorialRoute = DocumentationTutorialRouteImport.update({
  id: '/tutorial',
  path: '/tutorial',
  getParentRoute: () => DocumentationRoute,
} as any)
const DocumentationTolerancesRoute = DocumentationTolerancesRouteImport.update({
  id: '/tolerances',
  path: '/tolerances',
  getParentRoute: () => DocumentationRoute,
} as any)
const DocumentationStreamingGuideUnrealRoute =
  DocumentationStreamingGuideUnrealRouteImport.update({
    id: '/streaming-guide-unreal',
    path: '/streaming-guide-unreal',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationStreamingGuideUnityRoute =
  DocumentationStreamingGuideUnityRouteImport.update({
    id: '/streaming-guide-unity',
    path: '/streaming-guide-unity',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationStreamingGuideRoute =
  DocumentationStreamingGuideRouteImport.update({
    id: '/streaming-guide',
    path: '/streaming-guide',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationSdkReferenceRoute =
  DocumentationSdkReferenceRouteImport.update({
    id: '/sdk-reference',
    path: '/sdk-reference',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationOverviewRoute = DocumentationOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => DocumentationRoute,
} as any)
const DocumentationNetworkWhitelistingRoute =
  DocumentationNetworkWhitelistingRouteImport.update({
    id: '/network-whitelisting',
    path: '/network-whitelisting',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationNetworkConnectivityRequirementsRoute =
  DocumentationNetworkConnectivityRequirementsRouteImport.update({
    id: '/network-connectivity-requirements',
    path: '/network-connectivity-requirements',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationLocalAgentRoute = DocumentationLocalAgentRouteImport.update({
  id: '/local-agent',
  path: '/local-agent',
  getParentRoute: () => DocumentationRoute,
} as any)
const DocumentationInterlucentUploaderRoute =
  DocumentationInterlucentUploaderRouteImport.update({
    id: '/interlucent-uploader',
    path: '/interlucent-uploader',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationIdleTimerRoute = DocumentationIdleTimerRouteImport.update({
  id: '/idle-timer',
  path: '/idle-timer',
  getParentRoute: () => DocumentationRoute,
} as any)
const DocumentationAdmissionTokensRoute =
  DocumentationAdmissionTokensRouteImport.update({
    id: '/admission-tokens',
    path: '/admission-tokens',
    getParentRoute: () => DocumentationRoute,
  } as any)
const DocumentationAccessTokensRoute =
  DocumentationAccessTokensRouteImport.update({
    id: '/access-tokens',
    path: '/access-tokens',
    getParentRoute: () => DocumentationRoute,
  } as any)
const CheckSplatRoute = CheckSplatRouteImport.update({
  id: '/check/$',
  path: '/check/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminToolsRoute = AdminToolsRouteImport.update({
  id: '/admin/tools',
  path: '/admin/tools',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlanTiersRoute = AdminPlanTiersRouteImport.update({
  id: '/admin/plan-tiers',
  path: '/admin/plan-tiers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/admin/organizations',
  path: '/admin/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsProjectIdRoute,
} as any)
const AdminPoolsIndexRoute = AdminPoolsIndexRouteImport.update({
  id: '/admin/pools/',
  path: '/admin/pools/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdShareLinksRoute =
  ProjectsProjectIdShareLinksRouteImport.update({
    id: '/share-links',
    path: '/share-links',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdSettingsRoute =
  ProjectsProjectIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdOverviewRoute =
  ProjectsProjectIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdDomainsRoute =
  ProjectsProjectIdDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdAdmissionTokensRoute =
  ProjectsProjectIdAdmissionTokensRouteImport.update({
    id: '/admission-tokens',
    path: '/admission-tokens',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const AdminPoolsPricingRoute = AdminPoolsPricingRouteImport.update({
  id: '/admin/pools/pricing',
  path: '/admin/pools/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPoolsOnDemandAccessRoute =
  AdminPoolsOnDemandAccessRouteImport.update({
    id: '/admin/pools/on-demand-access',
    path: '/admin/pools/on-demand-access',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminPoolsNewPrivatePoolRoute =
  AdminPoolsNewPrivatePoolRouteImport.update({
    id: '/admin/pools/new-private-pool',
    path: '/admin/pools/new-private-pool',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminPoolsPoolIdRoute = AdminPoolsPoolIdRouteImport.update({
  id: '/admin/pools/$poolId',
  path: '/admin/pools/$poolId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdProfilesIndexRoute =
  ProjectsProjectIdProfilesIndexRouteImport.update({
    id: '/profiles/',
    path: '/profiles/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdApplicationsIndexRoute =
  ProjectsProjectIdApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdProfilesProfileIdRoute =
  ProjectsProjectIdProfilesProfileIdRouteImport.update({
    id: '/profiles/$profileId',
    path: '/profiles/$profileId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)
const ProjectsProjectIdApplicationsAppIdRoute =
  ProjectsProjectIdApplicationsAppIdRouteImport.update({
    id: '/applications/$appId',
    path: '/applications/$appId',
    getParentRoute: () => ProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/documentation': typeof DocumentationRouteWithChildren
  '/eula': typeof EulaRoute
  '/network-connectivity-requirements': typeof NetworkConnectivityRequirementsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password-task': typeof ResetPasswordTaskRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/plan-tiers': typeof AdminPlanTiersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/check/$': typeof CheckSplatRoute
  '/documentation/access-tokens': typeof DocumentationAccessTokensRoute
  '/documentation/admission-tokens': typeof DocumentationAdmissionTokensRoute
  '/documentation/idle-timer': typeof DocumentationIdleTimerRoute
  '/documentation/interlucent-uploader': typeof DocumentationInterlucentUploaderRoute
  '/documentation/local-agent': typeof DocumentationLocalAgentRoute
  '/documentation/network-connectivity-requirements': typeof DocumentationNetworkConnectivityRequirementsRoute
  '/documentation/network-whitelisting': typeof DocumentationNetworkWhitelistingRoute
  '/documentation/overview': typeof DocumentationOverviewRoute
  '/documentation/sdk-reference': typeof DocumentationSdkReferenceRoute
  '/documentation/streaming-guide': typeof DocumentationStreamingGuideRoute
  '/documentation/streaming-guide-unity': typeof DocumentationStreamingGuideUnityRoute
  '/documentation/streaming-guide-unreal': typeof DocumentationStreamingGuideUnrealRoute
  '/documentation/tolerances': typeof DocumentationTolerancesRoute
  '/documentation/tutorial': typeof DocumentationTutorialRoute
  '/documentation/tutorial-angular': typeof DocumentationTutorialAngularRoute
  '/documentation/tutorial-react': typeof DocumentationTutorialReactRoute
  '/documentation/tutorial-vue': typeof DocumentationTutorialVueRoute
  '/preview/$': typeof PreviewSplatRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/settings/subscription': typeof SettingsSubscriptionRoute
  '/admin': typeof AdminIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/documentation/': typeof DocumentationIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/admin/pools/$poolId': typeof AdminPoolsPoolIdRoute
  '/admin/pools/new-private-pool': typeof AdminPoolsNewPrivatePoolRoute
  '/admin/pools/on-demand-access': typeof AdminPoolsOnDemandAccessRoute
  '/admin/pools/pricing': typeof AdminPoolsPricingRoute
  '/projects/$projectId/admission-tokens': typeof ProjectsProjectIdAdmissionTokensRoute
  '/projects/$projectId/domains': typeof ProjectsProjectIdDomainsRoute
  '/projects/$projectId/overview': typeof ProjectsProjectIdOverviewRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/share-links': typeof ProjectsProjectIdShareLinksRoute
  '/admin/pools': typeof AdminPoolsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/applications/$appId': typeof ProjectsProjectIdApplicationsAppIdRoute
  '/projects/$projectId/profiles/$profileId': typeof ProjectsProjectIdProfilesProfileIdRoute
  '/projects/$projectId/applications': typeof ProjectsProjectIdApplicationsIndexRoute
  '/projects/$projectId/profiles': typeof ProjectsProjectIdProfilesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/eula': typeof EulaRoute
  '/network-connectivity-requirements': typeof NetworkConnectivityRequirementsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password-task': typeof ResetPasswordTaskRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/plan-tiers': typeof AdminPlanTiersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/check/$': typeof CheckSplatRoute
  '/documentation/access-tokens': typeof DocumentationAccessTokensRoute
  '/documentation/admission-tokens': typeof DocumentationAdmissionTokensRoute
  '/documentation/idle-timer': typeof DocumentationIdleTimerRoute
  '/documentation/interlucent-uploader': typeof DocumentationInterlucentUploaderRoute
  '/documentation/local-agent': typeof DocumentationLocalAgentRoute
  '/documentation/network-connectivity-requirements': typeof DocumentationNetworkConnectivityRequirementsRoute
  '/documentation/network-whitelisting': typeof DocumentationNetworkWhitelistingRoute
  '/documentation/overview': typeof DocumentationOverviewRoute
  '/documentation/sdk-reference': typeof DocumentationSdkReferenceRoute
  '/documentation/streaming-guide': typeof DocumentationStreamingGuideRoute
  '/documentation/streaming-guide-unity': typeof DocumentationStreamingGuideUnityRoute
  '/documentation/streaming-guide-unreal': typeof DocumentationStreamingGuideUnrealRoute
  '/documentation/tolerances': typeof DocumentationTolerancesRoute
  '/documentation/tutorial': typeof DocumentationTutorialRoute
  '/documentation/tutorial-angular': typeof DocumentationTutorialAngularRoute
  '/documentation/tutorial-react': typeof DocumentationTutorialReactRoute
  '/documentation/tutorial-vue': typeof DocumentationTutorialVueRoute
  '/preview/$': typeof PreviewSplatRoute
  '/settings/subscription': typeof SettingsSubscriptionRoute
  '/admin': typeof AdminIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/documentation': typeof DocumentationIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/admin/pools/$poolId': typeof AdminPoolsPoolIdRoute
  '/admin/pools/new-private-pool': typeof AdminPoolsNewPrivatePoolRoute
  '/admin/pools/on-demand-access': typeof AdminPoolsOnDemandAccessRoute
  '/admin/pools/pricing': typeof AdminPoolsPricingRoute
  '/projects/$projectId/admission-tokens': typeof ProjectsProjectIdAdmissionTokensRoute
  '/projects/$projectId/domains': typeof ProjectsProjectIdDomainsRoute
  '/projects/$projectId/overview': typeof ProjectsProjectIdOverviewRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/share-links': typeof ProjectsProjectIdShareLinksRoute
  '/admin/pools': typeof AdminPoolsIndexRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/applications/$appId': typeof ProjectsProjectIdApplicationsAppIdRoute
  '/projects/$projectId/profiles/$profileId': typeof ProjectsProjectIdProfilesProfileIdRoute
  '/projects/$projectId/applications': typeof ProjectsProjectIdApplicationsIndexRoute
  '/projects/$projectId/profiles': typeof ProjectsProjectIdProfilesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/documentation': typeof DocumentationRouteWithChildren
  '/eula': typeof EulaRoute
  '/network-connectivity-requirements': typeof NetworkConnectivityRequirementsRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/reset-password-task': typeof ResetPasswordTaskRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/terms': typeof TermsRoute
  '/admin/organizations': typeof AdminOrganizationsRoute
  '/admin/plan-tiers': typeof AdminPlanTiersRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/tools': typeof AdminToolsRoute
  '/check/$': typeof CheckSplatRoute
  '/documentation/access-tokens': typeof DocumentationAccessTokensRoute
  '/documentation/admission-tokens': typeof DocumentationAdmissionTokensRoute
  '/documentation/idle-timer': typeof DocumentationIdleTimerRoute
  '/documentation/interlucent-uploader': typeof DocumentationInterlucentUploaderRoute
  '/documentation/local-agent': typeof DocumentationLocalAgentRoute
  '/documentation/network-connectivity-requirements': typeof DocumentationNetworkConnectivityRequirementsRoute
  '/documentation/network-whitelisting': typeof DocumentationNetworkWhitelistingRoute
  '/documentation/overview': typeof DocumentationOverviewRoute
  '/documentation/sdk-reference': typeof DocumentationSdkReferenceRoute
  '/documentation/streaming-guide': typeof DocumentationStreamingGuideRoute
  '/documentation/streaming-guide-unity': typeof DocumentationStreamingGuideUnityRoute
  '/documentation/streaming-guide-unreal': typeof DocumentationStreamingGuideUnrealRoute
  '/documentation/tolerances': typeof DocumentationTolerancesRoute
  '/documentation/tutorial': typeof DocumentationTutorialRoute
  '/documentation/tutorial-angular': typeof DocumentationTutorialAngularRoute
  '/documentation/tutorial-react': typeof DocumentationTutorialReactRoute
  '/documentation/tutorial-vue': typeof DocumentationTutorialVueRoute
  '/preview/$': typeof PreviewSplatRoute
  '/projects/$projectId': typeof ProjectsProjectIdRouteWithChildren
  '/settings/subscription': typeof SettingsSubscriptionRoute
  '/admin/': typeof AdminIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/documentation/': typeof DocumentationIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/admin/pools/$poolId': typeof AdminPoolsPoolIdRoute
  '/admin/pools/new-private-pool': typeof AdminPoolsNewPrivatePoolRoute
  '/admin/pools/on-demand-access': typeof AdminPoolsOnDemandAccessRoute
  '/admin/pools/pricing': typeof AdminPoolsPricingRoute
  '/projects/$projectId/admission-tokens': typeof ProjectsProjectIdAdmissionTokensRoute
  '/projects/$projectId/domains': typeof ProjectsProjectIdDomainsRoute
  '/projects/$projectId/overview': typeof ProjectsProjectIdOverviewRoute
  '/projects/$projectId/settings': typeof ProjectsProjectIdSettingsRoute
  '/projects/$projectId/share-links': typeof ProjectsProjectIdShareLinksRoute
  '/admin/pools/': typeof AdminPoolsIndexRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/projects/$projectId/applications/$appId': typeof ProjectsProjectIdApplicationsAppIdRoute
  '/projects/$projectId/profiles/$profileId': typeof ProjectsProjectIdProfilesProfileIdRoute
  '/projects/$projectId/applications/': typeof ProjectsProjectIdApplicationsIndexRoute
  '/projects/$projectId/profiles/': typeof ProjectsProjectIdProfilesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/documentation'
    | '/eula'
    | '/network-connectivity-requirements'
    | '/onboarding'
    | '/privacy'
    | '/reset-password-task'
    | '/sso-callback'
    | '/terms'
    | '/admin/organizations'
    | '/admin/plan-tiers'
    | '/admin/reports'
    | '/admin/tools'
    | '/check/$'
    | '/documentation/access-tokens'
    | '/documentation/admission-tokens'
    | '/documentation/idle-timer'
    | '/documentation/interlucent-uploader'
    | '/documentation/local-agent'
    | '/documentation/network-connectivity-requirements'
    | '/documentation/network-whitelisting'
    | '/documentation/overview'
    | '/documentation/sdk-reference'
    | '/documentation/streaming-guide'
    | '/documentation/streaming-guide-unity'
    | '/documentation/streaming-guide-unreal'
    | '/documentation/tolerances'
    | '/documentation/tutorial'
    | '/documentation/tutorial-angular'
    | '/documentation/tutorial-react'
    | '/documentation/tutorial-vue'
    | '/preview/$'
    | '/projects/$projectId'
    | '/settings/subscription'
    | '/admin'
    | '/analytics'
    | '/documentation/'
    | '/projects'
    | '/settings'
    | '/admin/pools/$poolId'
    | '/admin/pools/new-private-pool'
    | '/admin/pools/on-demand-access'
    | '/admin/pools/pricing'
    | '/projects/$projectId/admission-tokens'
    | '/projects/$projectId/domains'
    | '/projects/$projectId/overview'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/share-links'
    | '/admin/pools'
    | '/projects/$projectId/'
    | '/projects/$projectId/applications/$appId'
    | '/projects/$projectId/profiles/$profileId'
    | '/projects/$projectId/applications'
    | '/projects/$projectId/profiles'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/eula'
    | '/network-connectivity-requirements'
    | '/onboarding'
    | '/privacy'
    | '/reset-password-task'
    | '/sso-callback'
    | '/terms'
    | '/admin/organizations'
    | '/admin/plan-tiers'
    | '/admin/reports'
    | '/admin/tools'
    | '/check/$'
    | '/documentation/access-tokens'
    | '/documentation/admission-tokens'
    | '/documentation/idle-timer'
    | '/documentation/interlucent-uploader'
    | '/documentation/local-agent'
    | '/documentation/network-connectivity-requirements'
    | '/documentation/network-whitelisting'
    | '/documentation/overview'
    | '/documentation/sdk-reference'
    | '/documentation/streaming-guide'
    | '/documentation/streaming-guide-unity'
    | '/documentation/streaming-guide-unreal'
    | '/documentation/tolerances'
    | '/documentation/tutorial'
    | '/documentation/tutorial-angular'
    | '/documentation/tutorial-react'
    | '/documentation/tutorial-vue'
    | '/preview/$'
    | '/settings/subscription'
    | '/admin'
    | '/analytics'
    | '/documentation'
    | '/projects'
    | '/settings'
    | '/admin/pools/$poolId'
    | '/admin/pools/new-private-pool'
    | '/admin/pools/on-demand-access'
    | '/admin/pools/pricing'
    | '/projects/$projectId/admission-tokens'
    | '/projects/$projectId/domains'
    | '/projects/$projectId/overview'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/share-links'
    | '/admin/pools'
    | '/projects/$projectId'
    | '/projects/$projectId/applications/$appId'
    | '/projects/$projectId/profiles/$profileId'
    | '/projects/$projectId/applications'
    | '/projects/$projectId/profiles'
  id:
    | '__root__'
    | '/'
    | '/documentation'
    | '/eula'
    | '/network-connectivity-requirements'
    | '/onboarding'
    | '/privacy'
    | '/reset-password-task'
    | '/sso-callback'
    | '/terms'
    | '/admin/organizations'
    | '/admin/plan-tiers'
    | '/admin/reports'
    | '/admin/tools'
    | '/check/$'
    | '/documentation/access-tokens'
    | '/documentation/admission-tokens'
    | '/documentation/idle-timer'
    | '/documentation/interlucent-uploader'
    | '/documentation/local-agent'
    | '/documentation/network-connectivity-requirements'
    | '/documentation/network-whitelisting'
    | '/documentation/overview'
    | '/documentation/sdk-reference'
    | '/documentation/streaming-guide'
    | '/documentation/streaming-guide-unity'
    | '/documentation/streaming-guide-unreal'
    | '/documentation/tolerances'
    | '/documentation/tutorial'
    | '/documentation/tutorial-angular'
    | '/documentation/tutorial-react'
    | '/documentation/tutorial-vue'
    | '/preview/$'
    | '/projects/$projectId'
    | '/settings/subscription'
    | '/admin/'
    | '/analytics/'
    | '/documentation/'
    | '/projects/'
    | '/settings/'
    | '/admin/pools/$poolId'
    | '/admin/pools/new-private-pool'
    | '/admin/pools/on-demand-access'
    | '/admin/pools/pricing'
    | '/projects/$projectId/admission-tokens'
    | '/projects/$projectId/domains'
    | '/projects/$projectId/overview'
    | '/projects/$projectId/settings'
    | '/projects/$projectId/share-links'
    | '/admin/pools/'
    | '/projects/$projectId/'
    | '/projects/$projectId/applications/$appId'
    | '/projects/$projectId/profiles/$profileId'
    | '/projects/$projectId/applications/'
    | '/projects/$projectId/profiles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocumentationRoute: typeof DocumentationRouteWithChildren
  EulaRoute: typeof EulaRoute
  NetworkConnectivityRequirementsRoute: typeof NetworkConnectivityRequirementsRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  ResetPasswordTaskRoute: typeof ResetPasswordTaskRoute
  SsoCallbackRoute: typeof SsoCallbackRoute
  TermsRoute: typeof TermsRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRoute
  AdminPlanTiersRoute: typeof AdminPlanTiersRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminToolsRoute: typeof AdminToolsRoute
  CheckSplatRoute: typeof CheckSplatRoute
  PreviewSplatRoute: typeof PreviewSplatRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRouteWithChildren
  SettingsSubscriptionRoute: typeof SettingsSubscriptionRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  AdminPoolsPoolIdRoute: typeof AdminPoolsPoolIdRoute
  AdminPoolsNewPrivatePoolRoute: typeof AdminPoolsNewPrivatePoolRoute
  AdminPoolsOnDemandAccessRoute: typeof AdminPoolsOnDemandAccessRoute
  AdminPoolsPricingRoute: typeof AdminPoolsPricingRoute
  AdminPoolsIndexRoute: typeof AdminPoolsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-task': {
      id: '/reset-password-task'
      path: '/reset-password-task'
      fullPath: '/reset-password-task'
      preLoaderRoute: typeof ResetPasswordTaskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/network-connectivity-requirements': {
      id: '/network-connectivity-requirements'
      path: '/network-connectivity-requirements'
      fullPath: '/network-connectivity-requirements'
      preLoaderRoute: typeof NetworkConnectivityRequirementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/eula': {
      id: '/eula'
      path: '/eula'
      fullPath: '/eula'
      preLoaderRoute: typeof EulaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentation': {
      id: '/documentation'
      path: '/documentation'
      fullPath: '/documentation'
      preLoaderRoute: typeof DocumentationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentation/': {
      id: '/documentation/'
      path: '/'
      fullPath: '/documentation/'
      preLoaderRoute: typeof DocumentationIndexRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/subscription': {
      id: '/settings/subscription'
      path: '/settings/subscription'
      fullPath: '/settings/subscription'
      preLoaderRoute: typeof SettingsSubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/preview/$': {
      id: '/preview/$'
      path: '/preview/$'
      fullPath: '/preview/$'
      preLoaderRoute: typeof PreviewSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documentation/tutorial-vue': {
      id: '/documentation/tutorial-vue'
      path: '/tutorial-vue'
      fullPath: '/documentation/tutorial-vue'
      preLoaderRoute: typeof DocumentationTutorialVueRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/tutorial-react': {
      id: '/documentation/tutorial-react'
      path: '/tutorial-react'
      fullPath: '/documentation/tutorial-react'
      preLoaderRoute: typeof DocumentationTutorialReactRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/tutorial-angular': {
      id: '/documentation/tutorial-angular'
      path: '/tutorial-angular'
      fullPath: '/documentation/tutorial-angular'
      preLoaderRoute: typeof DocumentationTutorialAngularRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/tutorial': {
      id: '/documentation/tutorial'
      path: '/tutorial'
      fullPath: '/documentation/tutorial'
      preLoaderRoute: typeof DocumentationTutorialRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/tolerances': {
      id: '/documentation/tolerances'
      path: '/tolerances'
      fullPath: '/documentation/tolerances'
      preLoaderRoute: typeof DocumentationTolerancesRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/streaming-guide-unreal': {
      id: '/documentation/streaming-guide-unreal'
      path: '/streaming-guide-unreal'
      fullPath: '/documentation/streaming-guide-unreal'
      preLoaderRoute: typeof DocumentationStreamingGuideUnrealRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/streaming-guide-unity': {
      id: '/documentation/streaming-guide-unity'
      path: '/streaming-guide-unity'
      fullPath: '/documentation/streaming-guide-unity'
      preLoaderRoute: typeof DocumentationStreamingGuideUnityRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/streaming-guide': {
      id: '/documentation/streaming-guide'
      path: '/streaming-guide'
      fullPath: '/documentation/streaming-guide'
      preLoaderRoute: typeof DocumentationStreamingGuideRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/sdk-reference': {
      id: '/documentation/sdk-reference'
      path: '/sdk-reference'
      fullPath: '/documentation/sdk-reference'
      preLoaderRoute: typeof DocumentationSdkReferenceRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/overview': {
      id: '/documentation/overview'
      path: '/overview'
      fullPath: '/documentation/overview'
      preLoaderRoute: typeof DocumentationOverviewRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/network-whitelisting': {
      id: '/documentation/network-whitelisting'
      path: '/network-whitelisting'
      fullPath: '/documentation/network-whitelisting'
      preLoaderRoute: typeof DocumentationNetworkWhitelistingRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/network-connectivity-requirements': {
      id: '/documentation/network-connectivity-requirements'
      path: '/network-connectivity-requirements'
      fullPath: '/documentation/network-connectivity-requirements'
      preLoaderRoute: typeof DocumentationNetworkConnectivityRequirementsRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/local-agent': {
      id: '/documentation/local-agent'
      path: '/local-agent'
      fullPath: '/documentation/local-agent'
      preLoaderRoute: typeof DocumentationLocalAgentRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/interlucent-uploader': {
      id: '/documentation/interlucent-uploader'
      path: '/interlucent-uploader'
      fullPath: '/documentation/interlucent-uploader'
      preLoaderRoute: typeof DocumentationInterlucentUploaderRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/idle-timer': {
      id: '/documentation/idle-timer'
      path: '/idle-timer'
      fullPath: '/documentation/idle-timer'
      preLoaderRoute: typeof DocumentationIdleTimerRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/admission-tokens': {
      id: '/documentation/admission-tokens'
      path: '/admission-tokens'
      fullPath: '/documentation/admission-tokens'
      preLoaderRoute: typeof DocumentationAdmissionTokensRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/documentation/access-tokens': {
      id: '/documentation/access-tokens'
      path: '/access-tokens'
      fullPath: '/documentation/access-tokens'
      preLoaderRoute: typeof DocumentationAccessTokensRouteImport
      parentRoute: typeof DocumentationRoute
    }
    '/check/$': {
      id: '/check/$'
      path: '/check/$'
      fullPath: '/check/$'
      preLoaderRoute: typeof CheckSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tools': {
      id: '/admin/tools'
      path: '/admin/tools'
      fullPath: '/admin/tools'
      preLoaderRoute: typeof AdminToolsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/admin/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/plan-tiers': {
      id: '/admin/plan-tiers'
      path: '/admin/plan-tiers'
      fullPath: '/admin/plan-tiers'
      preLoaderRoute: typeof AdminPlanTiersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/admin/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/admin/pools/': {
      id: '/admin/pools/'
      path: '/admin/pools'
      fullPath: '/admin/pools'
      preLoaderRoute: typeof AdminPoolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/share-links': {
      id: '/projects/$projectId/share-links'
      path: '/share-links'
      fullPath: '/projects/$projectId/share-links'
      preLoaderRoute: typeof ProjectsProjectIdShareLinksRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/settings': {
      id: '/projects/$projectId/settings'
      path: '/settings'
      fullPath: '/projects/$projectId/settings'
      preLoaderRoute: typeof ProjectsProjectIdSettingsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/overview': {
      id: '/projects/$projectId/overview'
      path: '/overview'
      fullPath: '/projects/$projectId/overview'
      preLoaderRoute: typeof ProjectsProjectIdOverviewRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/domains': {
      id: '/projects/$projectId/domains'
      path: '/domains'
      fullPath: '/projects/$projectId/domains'
      preLoaderRoute: typeof ProjectsProjectIdDomainsRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/admission-tokens': {
      id: '/projects/$projectId/admission-tokens'
      path: '/admission-tokens'
      fullPath: '/projects/$projectId/admission-tokens'
      preLoaderRoute: typeof ProjectsProjectIdAdmissionTokensRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/admin/pools/pricing': {
      id: '/admin/pools/pricing'
      path: '/admin/pools/pricing'
      fullPath: '/admin/pools/pricing'
      preLoaderRoute: typeof AdminPoolsPricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pools/on-demand-access': {
      id: '/admin/pools/on-demand-access'
      path: '/admin/pools/on-demand-access'
      fullPath: '/admin/pools/on-demand-access'
      preLoaderRoute: typeof AdminPoolsOnDemandAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pools/new-private-pool': {
      id: '/admin/pools/new-private-pool'
      path: '/admin/pools/new-private-pool'
      fullPath: '/admin/pools/new-private-pool'
      preLoaderRoute: typeof AdminPoolsNewPrivatePoolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/pools/$poolId': {
      id: '/admin/pools/$poolId'
      path: '/admin/pools/$poolId'
      fullPath: '/admin/pools/$poolId'
      preLoaderRoute: typeof AdminPoolsPoolIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/profiles/': {
      id: '/projects/$projectId/profiles/'
      path: '/profiles'
      fullPath: '/projects/$projectId/profiles'
      preLoaderRoute: typeof ProjectsProjectIdProfilesIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/applications/': {
      id: '/projects/$projectId/applications/'
      path: '/applications'
      fullPath: '/projects/$projectId/applications'
      preLoaderRoute: typeof ProjectsProjectIdApplicationsIndexRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/profiles/$profileId': {
      id: '/projects/$projectId/profiles/$profileId'
      path: '/profiles/$profileId'
      fullPath: '/projects/$projectId/profiles/$profileId'
      preLoaderRoute: typeof ProjectsProjectIdProfilesProfileIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
    '/projects/$projectId/applications/$appId': {
      id: '/projects/$projectId/applications/$appId'
      path: '/applications/$appId'
      fullPath: '/projects/$projectId/applications/$appId'
      preLoaderRoute: typeof ProjectsProjectIdApplicationsAppIdRouteImport
      parentRoute: typeof ProjectsProjectIdRoute
    }
  }
}

interface DocumentationRouteChildren {
  DocumentationAccessTokensRoute: typeof DocumentationAccessTokensRoute
  DocumentationAdmissionTokensRoute: typeof DocumentationAdmissionTokensRoute
  DocumentationIdleTimerRoute: typeof DocumentationIdleTimerRoute
  DocumentationInterlucentUploaderRoute: typeof DocumentationInterlucentUploaderRoute
  DocumentationLocalAgentRoute: typeof DocumentationLocalAgentRoute
  DocumentationNetworkConnectivityRequirementsRoute: typeof DocumentationNetworkConnectivityRequirementsRoute
  DocumentationNetworkWhitelistingRoute: typeof DocumentationNetworkWhitelistingRoute
  DocumentationOverviewRoute: typeof DocumentationOverviewRoute
  DocumentationSdkReferenceRoute: typeof DocumentationSdkReferenceRoute
  DocumentationStreamingGuideRoute: typeof DocumentationStreamingGuideRoute
  DocumentationStreamingGuideUnityRoute: typeof DocumentationStreamingGuideUnityRoute
  DocumentationStreamingGuideUnrealRoute: typeof DocumentationStreamingGuideUnrealRoute
  DocumentationTolerancesRoute: typeof DocumentationTolerancesRoute
  DocumentationTutorialRoute: typeof DocumentationTutorialRoute
  DocumentationTutorialAngularRoute: typeof DocumentationTutorialAngularRoute
  DocumentationTutorialReactRoute: typeof DocumentationTutorialReactRoute
  DocumentationTutorialVueRoute: typeof DocumentationTutorialVueRoute
  DocumentationIndexRoute: typeof DocumentationIndexRoute
}

const DocumentationRouteChildren: DocumentationRouteChildren = {
  DocumentationAccessTokensRoute: DocumentationAccessTokensRoute,
  DocumentationAdmissionTokensRoute: DocumentationAdmissionTokensRoute,
  DocumentationIdleTimerRoute: DocumentationIdleTimerRoute,
  DocumentationInterlucentUploaderRoute: DocumentationInterlucentUploaderRoute,
  DocumentationLocalAgentRoute: DocumentationLocalAgentRoute,
  DocumentationNetworkConnectivityRequirementsRoute:
    DocumentationNetworkConnectivityRequirementsRoute,
  DocumentationNetworkWhitelistingRoute: DocumentationNetworkWhitelistingRoute,
  DocumentationOverviewRoute: DocumentationOverviewRoute,
  DocumentationSdkReferenceRoute: DocumentationSdkReferenceRoute,
  DocumentationStreamingGuideRoute: DocumentationStreamingGuideRoute,
  DocumentationStreamingGuideUnityRoute: DocumentationStreamingGuideUnityRoute,
  DocumentationStreamingGuideUnrealRoute:
    DocumentationStreamingGuideUnrealRoute,
  DocumentationTolerancesRoute: DocumentationTolerancesRoute,
  DocumentationTutorialRoute: DocumentationTutorialRoute,
  DocumentationTutorialAngularRoute: DocumentationTutorialAngularRoute,
  DocumentationTutorialReactRoute: DocumentationTutorialReactRoute,
  DocumentationTutorialVueRoute: DocumentationTutorialVueRoute,
  DocumentationIndexRoute: DocumentationIndexRoute,
}

const DocumentationRouteWithChildren = DocumentationRoute._addFileChildren(
  DocumentationRouteChildren,
)

interface ProjectsProjectIdRouteChildren {
  ProjectsProjectIdAdmissionTokensRoute: typeof ProjectsProjectIdAdmissionTokensRoute
  ProjectsProjectIdDomainsRoute: typeof ProjectsProjectIdDomainsRoute
  ProjectsProjectIdOverviewRoute: typeof ProjectsProjectIdOverviewRoute
  ProjectsProjectIdSettingsRoute: typeof ProjectsProjectIdSettingsRoute
  ProjectsProjectIdShareLinksRoute: typeof ProjectsProjectIdShareLinksRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  ProjectsProjectIdApplicationsAppIdRoute: typeof ProjectsProjectIdApplicationsAppIdRoute
  ProjectsProjectIdProfilesProfileIdRoute: typeof ProjectsProjectIdProfilesProfileIdRoute
  ProjectsProjectIdApplicationsIndexRoute: typeof ProjectsProjectIdApplicationsIndexRoute
  ProjectsProjectIdProfilesIndexRoute: typeof ProjectsProjectIdProfilesIndexRoute
}

const ProjectsProjectIdRouteChildren: ProjectsProjectIdRouteChildren = {
  ProjectsProjectIdAdmissionTokensRoute: ProjectsProjectIdAdmissionTokensRoute,
  ProjectsProjectIdDomainsRoute: ProjectsProjectIdDomainsRoute,
  ProjectsProjectIdOverviewRoute: ProjectsProjectIdOverviewRoute,
  ProjectsProjectIdSettingsRoute: ProjectsProjectIdSettingsRoute,
  ProjectsProjectIdShareLinksRoute: ProjectsProjectIdShareLinksRoute,
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
  ProjectsProjectIdApplicationsAppIdRoute:
    ProjectsProjectIdApplicationsAppIdRoute,
  ProjectsProjectIdProfilesProfileIdRoute:
    ProjectsProjectIdProfilesProfileIdRoute,
  ProjectsProjectIdApplicationsIndexRoute:
    ProjectsProjectIdApplicationsIndexRoute,
  ProjectsProjectIdProfilesIndexRoute: ProjectsProjectIdProfilesIndexRoute,
}

const ProjectsProjectIdRouteWithChildren =
  ProjectsProjectIdRoute._addFileChildren(ProjectsProjectIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocumentationRoute: DocumentationRouteWithChildren,
  EulaRoute: EulaRoute,
  NetworkConnectivityRequirementsRoute: NetworkConnectivityRequirementsRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  ResetPasswordTaskRoute: ResetPasswordTaskRoute,
  SsoCallbackRoute: SsoCallbackRoute,
  TermsRoute: TermsRoute,
  AdminOrganizationsRoute: AdminOrganizationsRoute,
  AdminPlanTiersRoute: AdminPlanTiersRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminToolsRoute: AdminToolsRoute,
  CheckSplatRoute: CheckSplatRoute,
  PreviewSplatRoute: PreviewSplatRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRouteWithChildren,
  SettingsSubscriptionRoute: SettingsSubscriptionRoute,
  AdminIndexRoute: AdminIndexRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  AdminPoolsPoolIdRoute: AdminPoolsPoolIdRoute,
  AdminPoolsNewPrivatePoolRoute: AdminPoolsNewPrivatePoolRoute,
  AdminPoolsOnDemandAccessRoute: AdminPoolsOnDemandAccessRoute,
  AdminPoolsPricingRoute: AdminPoolsPricingRoute,
  AdminPoolsIndexRoute: AdminPoolsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
